import { observer } from 'mobx-react-lite'
import { useAddOnsViewContext } from 'pages/settings/pages/addOns/context/addOnsViewContext'
import { AddOnCard } from 'pages/settings/ui/AddOnCard/AddOnCard'

export const BrandedUrlShortener = observer(() => {
  const store = useAddOnsViewContext()
  const { isActiveCustomDomain } = store.entities.shortLinkStore

  return (
    <AddOnCard
      icon='link'
      isActive={isActiveCustomDomain}
      iconFontSize={24}
      title='Branded URL Shortener'
      showSwitch={isActiveCustomDomain}
      price={store.brandedUrlShortenerPriceText}
      description='Shorten links using your own custom domain name. Registration is required.'
      onSeeDetailsClick={store.openBrandedUrlShortenerModal}
      onActionClick={store.brandedUrlShortenerOnActionClick}
      onSwitchChange={store.brandedUrlShortenerOnSwitchChange}
    />
  )
})
